import createIcon from '../../createIcon';

/**
 * @component @name Bluetooth
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMzU1IDcuNzFMMTIuNjQ1IDJIMTEuNjQ1VjkuNTlMNy4wNTUwMiA1TDUuNjQ1MDIgNi40MUwxMS4yMzUgMTJMNS42NDUwMiAxNy41OUw3LjA1NTAyIDE5TDExLjY0NSAxNC40MVYyMkgxMi42NDVMMTguMzU1IDE2LjI5TDE0LjA1NSAxMkwxOC4zNTUgNy43MVpNMTMuNjQ1IDUuODNMMTUuNTI1IDcuNzFMMTMuNjQ1IDkuNTlWNS44M1pNMTUuNTI1IDE2LjI5TDEzLjY0NSAxOC4xN1YxNC40MUwxNS41MjUgMTYuMjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bluetooth = createIcon('Bluetooth', [
  [
    'path',
    {
      d: 'M18.355 7.71L12.645 2H11.645V9.59L7.05502 5L5.64502 6.41L11.235 12L5.64502 17.59L7.05502 19L11.645 14.41V22H12.645L18.355 16.29L14.055 12L18.355 7.71ZM13.645 5.83L15.525 7.71L13.645 9.59V5.83ZM15.525 16.29L13.645 18.17V14.41L15.525 16.29Z',
      key: 'jr7cnj',
    },
  ],
]);

export default Bluetooth;
